import { call, fork, put, select, takeEvery, delay } from "redux-saga/effects";
import {
  GET_EXPERIMENT,
  ADD_EXPERIMENT,
  UPDATE_SINGLE_EXPERIMENT,
  UPDATE_EXPERIMENTS_STATUS
} from "./actionTypes";
import { getExperimentListPromise, editExperimentPromise, deleteExperimentByIds, getBaseInterfaceInfoPromise, saveSweepColumnsPromise, deleteExperimentGroupPromise, getInterfaceType, getPinSpiceModel, Model, checkSignalName, SweepContentData, BaseSweepConstructor } from "../../../../services/Rocky";
import { createExperimentSignalGroupUI, getBaseSweepingSSNData, getBaseSweepingContentData, getCopyExperimentData, updateExpAMIModelToIBISModel, changeSweepExpAMIModelToIBISModel } from "../../../../services/Rocky/sweep/sweepingHelper";
import { updateExperimentInfo, clearSweepInfo, updateSweepCreateStatus, updateAddLoading, updateStateInfo } from "./action";
import { getDefaultName } from "../../../../services/helper/setDefaultName";
import { ROCKY_EXPERIMENT_SETUP_VERSION } from "../../../../version";
import { message } from "antd";
import { VERIFY_RUNNING, WAITING } from "../../../../constants/verificationStatus";
import { getProjectType } from "../rocky/saga";
import { changeTabMenu, openTabFooter } from "../../../MonitorStore/action";
import { EXPERIMENTS } from "../../../../constants/treeConstants";
import { getInterfaceMonitor } from "../simulation/action";
import { getSweepStatus } from "../simulation/sweep/saga";
import { PROJECT_V2 } from "../../../../constants/projectVersion";
import { versionCompareSize } from "../../../../services/helper/dataProcess";
import { TRANSIENT } from "../../../../services/Rocky/constants";

function* getExp(action) {
  const { RockyReducer: { project: { currentProjectId, projectVersion, spiceList, onDieSpiceList, ibisList, ibisAmiList, vectorList }, rockySSN: { channelId, verificationId } } } = yield select();

  const { id } = action;
  let info = { base: {}, id: "", experiments: [] }, res = {}, groupId = "";
  try {
    groupId = id
    res = yield call(getExperimentListPromise, { experimentGroupId: groupId });
    SweepContentData.saveData(groupId, res);
  } catch (error) {
    console.error(error)
    return
  }

  const { experiments, baseVerificationId, tableColumns, sweepName = "", verificationName = "" } = res;
  let baseId = "", runningQueue = [], _tableColumns = tableColumns;

  let init = false;
  if (experiments && experiments.length) {
    if (experiments.length === 1 && (!experiments[0].content || !experiments[0].content.length)) {
      init = true;
    }
  } else {
    init = true;
  }

  let baseContent = null
  try {
    baseContent = yield call(getBaseInterfaceInfoPromise, baseVerificationId)
    const ddrType = yield call(getProjectType);
    BaseSweepConstructor.setInfo(baseContent, baseVerificationId, ddrType, projectVersion)
  } catch (error) {
    console.error(error)
    return
  }

  const getReduceData = (item) => {
    const { id, name, content, status } = item;
    if ([VERIFY_RUNNING, WAITING].includes(status)) {
      runningQueue.push(id)
    }
    return { id, name, /*version,, verificationId*/ Interfaces: content, status }
  }

  if (init) {
    if (baseContent && baseContent.ssn && baseContent.ssn.length) {
      // const new_ssn_info = getBaseSweepingSSNData(baseContent.ssn)
      const new_ssn_info = yield call(getBaseSweepingSSNData, baseContent.ssn)
      const new_content_info = getBaseSweepingContentData(baseContent.content)
      const signal_group_id = experiments && experiments[0] ? experiments[0].id : '';
      let base = {
        name: 'Base',
        content: new_ssn_info,
        config: new_content_info
      }
      const baseRes = yield call(editExperimentPromise, { ...base, id: signal_group_id, groupId: groupId, version: ROCKY_EXPERIMENT_SETUP_VERSION, projectId: currentProjectId });
      SweepContentData.updateExpContent(groupId, signal_group_id, baseRes)

      const content = baseRes.content.map(item => {
        return getReduceData(item)
      })

      base.content = content;
      base.config = new_content_info;
      base.id = baseRes.id;
      baseId = baseRes.id;
      base.status = baseRes.status;
      base.verificationId = baseRes.verificationId;
      base.version = baseRes.version;

      info = { base, experiments: [], id: groupId, forSim: [], sweepName, verificationName, hasSchematic: false };
    }
  } else {
    const updateExpList = yield call(getExperimentList, experiments)
    let _experiments = updateExpList.map(item => {
      const { content } = item;
      const _content = content.map(item => {
        return getReduceData(item)
      })
      return { ...item, content: _content }
    });
    const base = _experiments.find(item => item.name === 'Base') || {};
    baseId = base.id;
    const new_content_info = getBaseSweepingContentData(baseContent.content)
    base.config = new_content_info;
    const new_experiments = _experiments.filter(item => item.name !== 'Base');
    info = { base: { ...base }, experiments: new_experiments, id: groupId, forSim: [], sweepName, verificationName, hasSchematic: false }
  }

  if (info.base && info.base.id) {
    const experiment = info.base
    yield put(openTabFooter())

    yield put(changeTabMenu({
      menuType: "simulation",
      tabSelectKeys: ['monitor'],
      verificationName: experiment.name,
      currentVerificationId: experiment.verificationId,
      channelName: info.sweepName,
      currentChannelId: info.id,
      dataType: EXPERIMENTS,
    }))
    yield put(getInterfaceMonitor(experiment.verificationId))
  }

  if (!_tableColumns || !_tableColumns.length) {
    _tableColumns = [['pins', 'corner', 'simulation']]
    yield call(saveSweepColumnsPromise, { id: groupId, tableColumns: _tableColumns })
  }

  info.tableColumns = _tableColumns;

  yield put(updateExperimentInfo(info, 'all'))

  if (info.experiments && info.experiments.length) {
    const runList = info.experiments.filter(item => [WAITING, VERIFY_RUNNING].includes(item.status))
    if (runList && runList.length) {
      const experimentQueue = runList.map(item => item.verificationId)
      yield call(getSweepStatus, { experimentQueue: experimentQueue, groupId })
    }
  }
}

function* getExperimentList(experiments) {
  const { RockyReducer: { project: { currentProjectId } } } = yield select();
  let _experiments = JSON.parse(JSON.stringify(experiments))
  try {
    for (let expInfo of _experiments) {
      const { content } = expInfo;

      let _newContent = [...content], saveToServer = false;
      if (versionCompareSize(expInfo.version, '0.0.2')) {
        _newContent = yield call(changeSweepExpAMIModelToIBISModel, _newContent)
        saveToServer = true;
      }
      expInfo.content = _newContent

      if (saveToServer) {
        const res = yield call(editExperimentPromise, { ...expInfo, version: ROCKY_EXPERIMENT_SETUP_VERSION, projectId: currentProjectId })
        SweepContentData.updateExpContent(expInfo.groupId, expInfo.id, res)
      }
    }
    return _experiments
  } catch (e) {
    console.error(e)
  }
  return _experiments
}

function* updateExperimentInfoFun({ experiment, isCreate }) {
  const { RockyReducer: { project: { currentProjectId } } } = yield select();
  try {
    const create_ssn = experiment.content.map(item => {
      const data = createExperimentSignalGroupUI({ ...item }, 'content', isCreate)
      return { ...data }
    })
    const res = yield call(editExperimentPromise, { ...experiment, content: create_ssn, version: ROCKY_EXPERIMENT_SETUP_VERSION, projectId: currentProjectId })
    if (experiment.id) {
      SweepContentData.updateExpContent(experiment.groupId, experiment.id, res)
    } else {
      SweepContentData.addExpList(experiment.groupId, res)
    }

    const create_ssn_ui = res.content.map(item => {
      const data = createExperimentSignalGroupUI({ ...item })
      return { ...data }
    })
    return { ...res, content: create_ssn_ui }

  } catch (err) {
    console.error(err)
  }
}

function* addSingleExp(action) {
  const { RockyReducer: { sweep: { experimentInfo }, project: { currentProjectId } } } = yield select();
  const { experiments, base, id } = experimentInfo;
  const name = getDefaultName({ nameList: experiments, defaultKey: 'Exp_' });

  try {
    const res = yield call(updateExperimentInfoFun, { experiment: { id: '', config: {}, groupId: id, name, content: base.content, version: ROCKY_EXPERIMENT_SETUP_VERSION, projectId: currentProjectId }, isCreate: true })
    const newExperiments = [...experiments, { ...res }];
    yield put(updateExperimentInfo(newExperiments, 'experiments'))

  } catch (error) {
    console.error(error)
  }
  yield put(updateAddLoading(false))
}

function* updateSingleExp(action) {
  const { RockyReducer: { sweep: { experimentInfo }, project: { currentProjectId } } } = yield select();
  const { currentType, params } = action;
  switch (currentType) {
    case 'copy':
      yield call(copyExperiment, params);
      break;
    case 'add_sweep':
      yield call(getExp, {})
      break;
    case 'delete_sweep':
      yield call(deleteSweep, params);
      break;
    case 'delete':
      yield call(deleteExperiment, params);
      break;
    case 'rename':
      yield call(renameExperiment, params);
      break;
    case 'pins':
      yield call(updateExperimentPins, params);
      break;
    case 'create_by_model':
      yield call(createExperimentByModel, params);
      break;
    case 'content':
      yield call(updateExperimentContent, params);
      break;
    case 'table_display':
      yield call(updateExperimentCompDisplay, params);
      break;
    case 'create_exp':
      yield call(createExperiment, params);
      // yield call(addExperiment, params);
      break;
    case 'update_exp':
      yield call(updateExperiment, params);
      break;
    // case 'apply_setup':
    //   yield call(applyExpSetup, params);
    //   break;
    default: return;
  }
}

// function* applyExpSetup({ applySetupInfo, record }) {
//   const { RockyReducer: { sweep: { experimentInfo }, project: { currentProjectId } } } = yield select();
//   const { experiments, base } = experimentInfo;
//   const { copyList } = applySetupInfo;

//   const expIndex = experiments.findIndex(item => item.name === record.name)
//   if (expIndex < 0) { return }
//   const currentExperiment = JSON.parse(JSON.stringify(experiments[expIndex]));
//   let content = (currentExperiment.content)
//   const baseContent = base.content;
//   const copyInfo = content.find(item => record.signalGroupId === item.id)
//   if (!copyInfo) { return }

//   content.forEach(contentItem => {
//     if (copyList.includes(contentItem.id)) {
//       const value = getCopyExperimentData(contentItem, copyInfo, baseContent)
//       contentItem.Interfaces = value
//     }
//   })

//   let newExperiments = [...experiments];
//   newExperiments[expIndex] = currentExperiment;
//   yield call(updateExperimentInfoFun, { experiment: { ...currentExperiment } })
//   yield put(updateExperimentInfo(newExperiments, 'experiments'))
// }

function* createExperiment(params) {
  const { addInterfaceList } = params
  for (const info of addInterfaceList) {
    const { Interfaces, signalGroupName } = info
    if (Interfaces && Interfaces.length) {
      try {
        const { RockyReducer: { sweep: { experimentInfo }, project: { currentProjectId } } } = yield select();
        const { experiments, base, id } = experimentInfo;
        const name = getDefaultName({ nameList: experiments, defaultKey: 'Exp_' });

        let content = JSON.parse(JSON.stringify(base.content))

        const create_ssn = content.map(item => {
          let data = createExperimentSignalGroupUI({ ...item }, 'content', true)
          if (data.name === signalGroupName) {
            data.content = Interfaces
          }
          return { ...data }
        })

        const res = yield call(editExperimentPromise, { id: '', groupId: id, name, config: {}, content: create_ssn, version: ROCKY_EXPERIMENT_SETUP_VERSION, projectId: currentProjectId })
        SweepContentData.addExpList(id, res)

        const create_ssn_ui = res.content.map(item => {
          const data = createExperimentSignalGroupUI({ ...item })
          return { ...data }
        })

        const newExperiments = [...experiments, { ...res, content: create_ssn_ui }];
        yield put(updateExperimentInfo(newExperiments, 'experiments'))

      } catch (error) {
        console.error(error);
      }
    } else {
    }
  }
  yield put(updateSweepCreateStatus(false))
}

// function* addExperiment(params) {
//   const { RockyReducer: { sweep: { experimentInfo: { id: groupId, experiments } }, project: { currentProjectId } } } = yield select();
//   const nameList = experiments.map(exp => exp.name)
//   const name = getDefaultName({ nameList, defaultKey: 'Exp_' });
//   const { experiment: currentExperiment } = params;
//   try {
//     const res = yield call(updateExperimentInfoFun, { experiment: { id: '', config: currentExperiment.config || {}, groupId: groupId, name, content: currentExperiment.content, version: ROCKY_EXPERIMENT_SETUP_VERSION, projectId: currentProjectId } })
//     const newExperiments = [...experiments, { ...res }];
//     yield put(updateExperimentInfo(newExperiments, 'experiments'))
//   } catch (error) {
//     console.error(error)
//   }
//   yield put(updateAddLoading(false))
// }

function* updateExperiment(params) {
  const { experiment } = params;
  const { RockyReducer: { sweep: { experimentInfo: { experiments } } } } = yield select();
  let newExperiments = [...experiments];
  const expIndex = newExperiments.findIndex(item => item.id === experiment.id);
  if (expIndex === -1) { return }
  newExperiments[expIndex] = experiment;
  const currentExperiment = newExperiments[expIndex];
  yield call(updateExperimentInfoFun, { experiment: { ...currentExperiment } })
  yield put(updateExperimentInfo(newExperiments, 'experiments'))
}

function* createExperimentByModel(action) {
  const { modelsList } = action

  for (const model of modelsList) {
    const { Interfaces, signalGroupName } = model
    if (Interfaces && Interfaces.length) {
      try {
        const { RockyReducer: { sweep: { experimentInfo }, project: { currentProjectId } } } = yield select();
        const { experiments, base, id } = experimentInfo;
        const name = getDefaultName({ nameList: experiments, defaultKey: 'Exp_' });

        let content = JSON.parse(JSON.stringify(base.content))

        const create_ssn = content.map(item => {
          let data = createExperimentSignalGroupUI({ ...item }, 'content', true)
          if (data.name === signalGroupName) {
            data.content = Interfaces
          }
          return { ...data }
        })

        const res = yield call(editExperimentPromise, { id: '', groupId: id, name, config: {}, content: create_ssn, version: ROCKY_EXPERIMENT_SETUP_VERSION, projectId: currentProjectId })
        SweepContentData.addExpList(id, res)

        const create_ssn_ui = res.content.map(item => {
          const data = createExperimentSignalGroupUI({ ...item })
          return { ...data }
        })

        const newExperiments = [...experiments, { ...res, content: create_ssn_ui }];

        yield put(updateExperimentInfo(newExperiments, 'experiments'))

      } catch (error) {
        console.error(error);
      }
    } else {
      // yield call(addSingleExp)
    }
  }
  yield put(updateSweepCreateStatus(false))
  // yield put(getAllExpMeasurementConfig());
}

function* updateExperimentContent(params) {
  const { record, updateInfo } = params;
  const { RockyReducer: { sweep: { experimentInfo: { experiments } } } } = yield select();
  const expIndex = experiments.findIndex(item => item.id === record.experimentId);
  if (expIndex === -1) { return }
  const currentExperiment = experiments[expIndex];
  currentExperiment.config = { ...currentExperiment.config, ...updateInfo }
  let newExperiments = [...experiments];
  newExperiments[expIndex] = currentExperiment;
  yield call(updateExperimentInfoFun, { experiment: { ...currentExperiment } })
  yield put(updateExperimentInfo(newExperiments, 'experiments'))
}


function* updateExperimentCompDisplay(action) {
  const { base, experiments = [] } = action;

  yield put(updateExperimentInfo(base, 'base'));
  yield fork(updateExperimentInfoFun, { experiment: base });
  if (experiments && experiments.length) {
    yield put(updateExperimentInfo(experiments, 'experiments'));
    yield* experiments.map(function* (experiment) {
      yield fork(updateExperimentInfoFun, { experiment });
    })
  }
  yield put(updateExperimentInfo(true, 'update'));
}

function* updateExperimentPins(params) {
  const { record, info, applySetupInfo } = params;
  const { RockyReducer: { project: { projectVersion }, sweep: { experimentInfo: { experiments, base } } } } = yield select();

  const expIndex = experiments.findIndex(item => item.id === record.experimentId);
  if (expIndex === -1) { return }
  const currentExperiment = JSON.parse(JSON.stringify(experiments[expIndex]));

  const signalGroupIndex = currentExperiment.content.findIndex(item => item.id === record.signalGroupId);
  if (signalGroupIndex > -1) {
    currentExperiment.content[signalGroupIndex].Interfaces = info;
  }

  const baseSimulateMode = base.config && base.config.option && base.config.option.simConfig && base.config.option.simConfig.simulateMode ? base.config.option.simConfig.simulateMode : TRANSIENT
  const expSimulateMode = currentExperiment.config && currentExperiment.config.option && currentExperiment.config.option.simConfig && currentExperiment.config.option.simConfig.simulateMode ? currentExperiment.config.option.simConfig.simulateMode : TRANSIENT
  const expIsStatEye = expSimulateMode === 'Transient' ? false : expSimulateMode === 'StatEye' || baseSimulateMode === 'StatEye' ? true : false;
  const isJitter = expIsStatEye && projectVersion === PROJECT_V2 ? true : false;

  if (applySetupInfo && applySetupInfo.copyList && applySetupInfo.copyList.length > 0) {
    // apply setup to other interface
    const { copyList } = applySetupInfo;
    let content = (currentExperiment.content)
    const baseContent = base.content;
    const copyInfo = content.find(item => record.signalGroupId === item.id)
    if (!copyInfo) { return }

    content.forEach(contentItem => {
      if (copyList.includes(contentItem.id)) {
        const value = getCopyExperimentData(contentItem, copyInfo, baseContent, isJitter)
        contentItem.Interfaces = value
        // contentItem = value
      }
    })
  }

  let newExperiments = [...experiments];
  newExperiments[expIndex] = currentExperiment;
  yield call(updateExperimentInfoFun, { experiment: { ...currentExperiment } })
  yield put(updateExperimentInfo(newExperiments, 'experiments'))
}

function* deleteSweep() {
  const { RockyReducer: { sweep: { experimentInfo: { id } } } } = yield select();
  try {
    yield call(deleteExperimentGroupPromise, { experimentGroupId: id });
    // clean sweep data
    yield put(clearSweepInfo())
  } catch (error) {
    console.error("delete sweep error: ", error)
  }
}

function* deleteExperiment({ deleteArr }) {
  const { RockyReducer: { sweep: { experimentInfo: { experiments, id } } } } = yield select();
  if (deleteArr.length > 0) {
    try {
      yield call(deleteExperimentByIds, deleteArr);
      const newExperiments = experiments.filter(item => !deleteArr.includes(item.id))
      SweepContentData.deleteExpList(id, deleteArr)
      yield put(updateExperimentInfo(newExperiments, 'experiments'))
    } catch (error) {
      message.error(`Delete ${deleteArr.length === 1 ? 'experiment' : 'experiments'} failed!`)
    }
  }
}

function* copyExperiment({ experimentId }) {
  const { RockyReducer: { sweep: { experimentInfo: { id: groupId, experiments } }, project: { currentProjectId } } } = yield select();
  const nameList = experiments.map(exp => exp.name)
  const name = getDefaultName({ nameList, defaultKey: 'Exp_' });
  const currentExperiment = experiments.find(item => item.id === experimentId);

  try {
    const res = yield call(updateExperimentInfoFun, { experiment: { id: '', config: currentExperiment.config || {}, groupId: groupId, name, content: currentExperiment.content, version: ROCKY_EXPERIMENT_SETUP_VERSION, projectId: currentProjectId } })
    const newExperiments = [...experiments, { ...res }];
    yield put(updateExperimentInfo(newExperiments, 'experiments'))
  } catch (error) {
    console.error(error)
  }
  yield put(updateAddLoading(false))
}

function* renameExperiment({ name, experimentId }) {
  const { RockyReducer: { sweep: { experimentInfo: { id: groupId, experiments } } } } = yield select();
  const expIndex = experiments.findIndex(item => item.id === experimentId);
  if (expIndex > -1) {
    try {
      const currentExperiment = experiments[expIndex];
      yield call(updateExperimentInfoFun, { experiment: { ...currentExperiment, name, content: currentExperiment.content } })
      let newExperiments = [...experiments];
      newExperiments[expIndex].name = name;
      SweepContentData.updateExpContent(groupId, currentExperiment.id, { name })
      yield put(updateExperimentInfo(newExperiments, 'experiments'))
    } catch (error) {
      message.error(`Rename experiment failed!`)
    }
  }
}

function* updateExperimentsStatus(action) {
  const { experimentIds, status } = action;
  const { RockyReducer: { sweep: { experimentInfo: { experiments } } } } = yield select();
  let newExperiments = [...experiments];
  for (let id of experimentIds) {
    const index = newExperiments.findIndex(item => item.id === id || item.verificationId === id);
    if (index > -1) {
      newExperiments[index].status = status;
    }
  }
  yield put(updateExperimentInfo(newExperiments, 'experiments'))
}

export default function* sierraSweepSaga() {
  yield takeEvery(GET_EXPERIMENT, getExp);
  yield takeEvery(ADD_EXPERIMENT, addSingleExp);
  yield takeEvery(UPDATE_SINGLE_EXPERIMENT, updateSingleExp);
  yield takeEvery(UPDATE_EXPERIMENTS_STATUS, updateExperimentsStatus);
}